import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';
import React from 'react';
import DrawnCategoryItem from './DrawnCategoryItem';

interface SortableCategoryItemProps {
  id: string;
  title: string;
  onDelete: () => void;
}

const SortableCategoryItem: React.FC<SortableCategoryItemProps> = ({ id, title, onDelete }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const style = {
    opacity: isDragging ? 0.3 : 1,
  };

  const draggableStyle = {
    transform: CSS.Transform.toString(transform),
    transition: transition || 'transform 200ms ease',
    touchAction: 'none',
    cursor: isDragging ? 'grabbing' : 'grab',
    zIndex: isDragging ? 1000 : 'auto',
  };

  return (
    <Box ref={setNodeRef} {...attributes} {...listeners} style={{ ...style, ...draggableStyle }}>
      <DrawnCategoryItem title={title} onDelete={onDelete} />
    </Box>
  );
};

export default SortableCategoryItem;
